import {
    Button,
    styled,
    Typography,
} from "@material-ui/core";
import {
    DeleteOutline,
} from '@material-ui/icons';
import {
    Alert
} from '@material-ui/lab';
import FullPageCircularProgress from "components/full-page-circular-progress";
import { brand } from "../../theme";

export const CancelButton = styled( (p) =>
    <Button {...p} color="inherit">
        Cancel
    </Button>
)(({theme}) => ({
    marginRight: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));


export const UpdateButton = styled( ({isSaving, ...p}: any) =>
    <Button {...p} color="inherit" disabled={isSaving || false}>
        {isSaving ? 'Updating...' : 'Update'}
    </Button>
)(({theme}) => ({
    marginLeft: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));

export const CircularProgress = FullPageCircularProgress;

export const InformationMessage = styled(p =>
    <Alert
        variant="standard"
        severity="info"
        icon={false}
        {...p}
    />
)(({theme}) => ({
    borderRadius: 0,
    background: brand.warnBg,
    color: brand.warn,
    fontSize: 13,
    lineHeight: 1.5,
    padding: theme.spacing(1.5, 2.5),
    borderBottom: `1px solid ${brand.warn}22`,
    '& .MuiAlert-message': {
        padding: 0,
        color: brand.warn,
    },
}));

export const DangerZoneSection = styled('section')(({theme}) => ({
    padding: theme.spacing(3, 3, 6, 3),
    maxWidth: 960,
    margin: '0 auto',
    width: '100%',
}));

export const DangerZoneTitle = styled(Typography)(({theme}) => ({
    fontSize: 24,
    fontWeight: 800,
    color: brand.text,
    marginBottom: theme.spacing(1),
    letterSpacing: -0.3,
}));

export const DangerZoneDescription = styled(Typography)(({theme}) => ({
    fontSize: 14,
    lineHeight: 1.5,
    color: brand.textSec,
    marginBottom: theme.spacing(2),
}));

export const DeleteEventButton = styled(({deleting, ...p}: any) => (
    <Button
        variant="contained"
        startIcon={<DeleteOutline />}
        disabled={deleting || false}
        {...p}
    >
        {deleting ? 'Deleting...' : 'Delete Event'}
    </Button>
))(({theme}) => ({
    width: '100%',
    height: 52,
    borderRadius: 12,
    background: brand.error,
    color: brand.white,
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    boxShadow: 'none',
    '&:hover': {
        background: brand.error,
        opacity: 0.9,
        boxShadow: 'none',
    },
    '&.Mui-disabled': {
        background: '#F5C5C5',
        color: brand.white,
    },
}));
